import { useMutation } from '@tanstack/react-query'
import { httpClient } from '@/api/http-client'
import { CreateGoogleSessionBody, CreateSessionResponse } from '@/types'
import { MutationOptions } from '@/api/react-query'

async function createGoogleSession(body: CreateGoogleSessionBody) {
  const response = await httpClient('user-manager').post(
    '/v1/session/google/app',
    body,
  )

  return response.data
}
export function useCreateGoogleSession(
  options?: MutationOptions<CreateSessionResponse, CreateGoogleSessionBody>,
) {
  return useMutation({
    mutationFn: createGoogleSession,
    ...options,
  })
}
